// extracted by mini-css-extract-plugin
module.exports = {"custom":"_15e230f5f7f48acc764075f51b23bf26-less"};